// extracted by mini-css-extract-plugin
module.exports = {"guide":"ContractB_guide__1t3sp","intro":"ContractB_intro__2ZRvA","intro_1":"ContractB_intro_1__1zLTN"};